
import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface Urls {
    slug: string;
    type: number;
    id: number;
}

export interface SettingState {
  urls: Urls[];
}

const initialState: SettingState = {
    urls: [],
}
export const settingSlice = createSlice({
  name: 'setting',
  initialState,
  reducers: {
    setUrls: (state, action: PayloadAction<Urls[]>) => {
      state.urls = action.payload
    },
  },
})

export const { setUrls } = settingSlice.actions
export default settingSlice.reducer
